import React, { FC, useState, useEffect } from 'react';
import { Box, TextField, Checkbox, Button, Chip, OutlinedInput } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import InputAdornment from '@mui/material/InputAdornment';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import InfoIcon from '@mui/icons-material/Info';
import NavigationIcon from '@mui/icons-material/Navigation';
import LanguageIcon from '@mui/icons-material/Language';
import SettingsIcon from '@mui/icons-material/Settings';
import { useTranslation } from 'react-i18next';
import GeneralQuery from '../../../services/query/general/GeneralQuery.services';
interface IProps {
    selectedRow?: any;
    onAddMenu?: any;
    onEditMenu?: any;
    onCloseMenu?: any;
    parent?: any;
    menuappList?: any;
    menuWithApp?: any;
}

interface MenuInput {
    parentMenuId: number | null;
    menuNameKey: string;
    menuOrder: number;
    applicationId: number;
    iconName: string;
    menuDescription: string;
    isActive: boolean | undefined;
    isGlobalMenuItem: boolean;
    isHidden: boolean | undefined;
    menuNavigation: string;
    menuId: string;
    regionId: number;
    countryIdList: number[];
}

export const SCUIMenuManagementDialogContent: FC<IProps> = ({
    selectedRow = null,
    onAddMenu,
    onEditMenu,
    onCloseMenu,
    parent,
    menuWithApp,
}) => {
    const { t } = useTranslation();
    const [countryDatas, setCountryDatas] = useState<any>([]);
    const [selectedCountries, setSelectedCountries] = useState<number[]>(selectedRow?.countryIdList || []);

    let array_: any = [
        {
            menuDescription: 'Ana Menü',
            menuId: 0,
            menuNameKey: 'Ana Menü',
        },
    ];
    let arr: any = [...array_, ...parent];
    const [menuInput, setMenuInput] = useState<MenuInput>({
        parentMenuId: selectedRow?.parentMenuItemId ? Number(selectedRow.parentMenuItemId) : null,
        menuNameKey: selectedRow?.text || '',
        menuOrder: selectedRow?.orderNo ? Number(selectedRow.orderNo) : 0,
        applicationId: Number(menuWithApp),
        iconName: selectedRow?.iconName || '',
        menuDescription: selectedRow?.menuDescription || '',
        isActive: selectedRow?.isActive ?? undefined,
        isGlobalMenuItem: selectedRow?.isGlobalMenuItem || false,
        isHidden: selectedRow?.isHidden ?? undefined,
        menuNavigation: selectedRow?.navigateViewUrl || '',
        menuId: selectedRow?.menuItemId || '',
        regionId: JSON.parse(localStorage.getItem('selectedCountry') || '{}')?.regionId,
        countryIdList: selectedRow?.countryIdList || [],
    });
    menuInput.parentMenuId = menuInput.parentMenuId === 0 ? null : menuInput.parentMenuId;

    const getAllActiveCountryLanguagesForBackoffice = () => {
        const instanceId = parseInt(import.meta.env.VITE_INSTANCEID || '1');
        GeneralQuery.GetAllActiveCountryLanguagesForBackoffice(instanceId)
            .then((res: any) => {
                if (res) {
                    const countries = res.data?.boSupportedCountries || [];
                    // Sort countries by name
                    const sortedCountries = countries.sort((a: any, b: any) =>
                        a.countryName.localeCompare(b.countryName)
                    );
                    setCountryDatas(sortedCountries);
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            });
    };

    useEffect(() => {
        getAllActiveCountryLanguagesForBackoffice();
    }, []);

    useEffect(() => {
        if (selectedRow?.countryIdList) {
            setSelectedCountries(selectedRow.countryIdList);
            setMenuInput((prev) => ({
                ...prev,
                countryIdList: selectedRow.countryIdList,
            }));
        }
    }, [selectedRow]);

    const handleSelectParent = (e: any) => {
        setMenuInput({ ...menuInput, parentMenuId: e.target.value });
    };

    const handleCountrySelect = (e: any) => {
        const selectedCountryIds = e.target.value as number[];
        setSelectedCountries(selectedCountryIds);
        setMenuInput({ ...menuInput, countryIdList: selectedCountryIds });
    };

    const submitHandler = (event: any) => {
        event.preventDefault();
        onAddMenu(menuInput);
    };
    const guncelle = (event: any) => {
        event.preventDefault();
        onEditMenu(menuInput);
    };

    const sectionCardSx = {
        marginBottom: '12px',
        padding: '12px 14px',
        borderRadius: '8px',
        border: '1px solid #e3f2fd',
        backgroundColor: '#fff',
        boxShadow: '0 1px 4px rgba(25, 118, 210, 0.07)',
        transition: 'box-shadow 0.2s ease, border-color 0.2s ease, transform 0.2s ease',
        '&:hover': {
            boxShadow: '0 4px 14px rgba(25, 118, 210, 0.13)',
            borderColor: '#90caf9',
        },
        '&:last-child': {
            marginBottom: 0,
        },
    };

    const sectionTitleSx = {
        margin: '0 0 10px 0',
        fontSize: '12px',
        fontWeight: 700,
        letterSpacing: '0.06em',
        textTransform: 'uppercase' as const,
        color: '#1565c0',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        lineHeight: 1,
        paddingBottom: '8px',
        borderBottom: '1px solid #e3f2fd',
        '& .section-icon': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 26,
            height: 26,
            borderRadius: '6px',
            backgroundColor: '#e3f2fd',
            border: '1px solid #bbdefb',
            flexShrink: 0,
            transition: 'background-color 0.2s ease, border-color 0.2s ease',
        },
    };

    const fieldSx = { marginBottom: '10px' };

    const inputFieldSx = {
        ...fieldSx,
        '& .MuiInputLabel-root': {
            fontSize: '13px',
            fontWeight: 500,
            color: '#546e7a',
        },
        '& .MuiInputBase-input': {
            fontSize: '13.5px',
            fontWeight: 400,
            color: '#263238',
        },
        '& .MuiOutlinedInput-root': {
            borderRadius: '6px',
            backgroundColor: '#fafbfc',
            transition: 'box-shadow 0.2s ease, background-color 0.2s ease',
            '& fieldset': {
                borderColor: '#cfd8dc',
            },
            '&:hover': {
                backgroundColor: '#fff',
                '& fieldset': {
                    borderColor: '#90caf9',
                },
            },
            '&.Mui-focused': {
                backgroundColor: '#fff',
                boxShadow: '0 0 0 3px rgba(25, 118, 210, 0.1)',
                '& fieldset': {
                    borderColor: '#1976d2',
                    borderWidth: '1.5px',
                },
            },
        },
    };

    const renderSectionTitle = (icon: React.ReactNode, label: string) => (
        <Box component="h3" sx={sectionTitleSx}>
            <Box className="section-icon">{icon}</Box>
            <Box component="span" sx={{ pt: '1px' }}>
                {label}
            </Box>
        </Box>
    );

    return (
        <div>
            <form onSubmit={submitHandler}>
                <DialogContent
                    sx={{
                        padding: '14px 20px',
                        overflow: 'hidden',
                        backgroundColor: '#f5f8fc',
                        '& .MuiFormControl-root': {
                            marginBottom: '10px',
                        },
                        '& .MuiFormControl-root:last-of-type': {
                            marginBottom: 0,
                        },
                    }}
                >
                    <Box sx={{ display: 'flex', gap: 2.5, alignItems: 'flex-start' }}>
                        <Box sx={{ flex: 1, minWidth: 0 }}>
                            {/* Basic Information Section */}
                            <Box sx={sectionCardSx}>
                                {renderSectionTitle(
                                    <InfoIcon sx={{ fontSize: 15, color: '#1976d2' }} />,
                                    t('menuManagement.basicInformation')
                                )}

                                <FormControl fullWidth size="small" sx={{ ...inputFieldSx, marginTop: '6px' }}>
                                    <InputLabel id="parentMenuLabel">{t('menuManagement.associatedMenu')}</InputLabel>
                                    <Select
                                        fullWidth
                                        size="small"
                                        labelId="parentMenuLabel"
                                        id="parentMenuLabel"
                                        value={menuInput.parentMenuId}
                                        onChange={(e) => handleSelectParent(e)}
                                        variant="outlined"
                                    >
                                        {arr &&
                                            arr.map((parent: any) => (
                                                <MenuItem key={parent.menuId} value={parent.menuId}>
                                                    {parent.menuNameKey}
                                                </MenuItem>
                                            ))}
                                    </Select>
                                </FormControl>

                                <TextField
                                    margin="dense"
                                    size="small"
                                    id="menuOrder"
                                    label={t('general.orderSira')}
                                    type="number"
                                    fullWidth
                                    variant="outlined"
                                    defaultValue={menuInput.menuOrder}
                                    onChange={(e) => setMenuInput({ ...menuInput, menuOrder: Number(e.target.value) })}
                                    sx={inputFieldSx}
                                />

                                <TextField
                                    margin="dense"
                                    size="small"
                                    id="menuNameKey"
                                    label={t('general.text')}
                                    type="text"
                                    fullWidth
                                    variant="outlined"
                                    defaultValue={menuInput.menuNameKey}
                                    onChange={(e) => setMenuInput({ ...menuInput, menuNameKey: e.target.value })}
                                    sx={inputFieldSx}
                                />

                                <TextField
                                    margin="dense"
                                    size="small"
                                    id="menuDescription"
                                    label={t('general.description')}
                                    type="text"
                                    fullWidth
                                    variant="outlined"
                                    defaultValue={menuInput.menuDescription}
                                    onChange={(e) => setMenuInput({ ...menuInput, menuDescription: e.target.value })}
                                    sx={{ ...inputFieldSx, marginBottom: 0 }}
                                />
                            </Box>

                            {/* Navigation & Icon Section */}
                            <Box sx={sectionCardSx}>
                                {renderSectionTitle(
                                    <NavigationIcon sx={{ fontSize: 15, color: '#1976d2' }} />,
                                    t('menuManagement.navigationAndIcon')
                                )}

                                <TextField
                                    margin="dense"
                                    size="small"
                                    id="menuNavigation"
                                    label="URL"
                                    type="text"
                                    fullWidth
                                    variant="outlined"
                                    defaultValue={selectedRow ? selectedRow?.navigateViewUrl : ''}
                                    onChange={(e) => setMenuInput({ ...menuInput, menuNavigation: e.target.value })}
                                    sx={inputFieldSx}
                                />

                                <TextField
                                    margin="dense"
                                    size="small"
                                    id="iconName"
                                    label={t('general.icon')}
                                    type="text"
                                    fullWidth
                                    variant="outlined"
                                    slotProps={{
                                        input: {
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <Tooltip title={t('menuManagement.iconTooltipText')}>
                                                        <IconButton
                                                            size="small"
                                                            sx={{
                                                                color: '#546e7a',
                                                                '&:hover': {
                                                                    color: '#1976d2',
                                                                    backgroundColor: '#e3f2fd',
                                                                },
                                                            }}
                                                            onClick={() => {
                                                                window.open(
                                                                    'https://mui.com/material-ui/material-icons/',
                                                                    '_blank',
                                                                    'noopener,noreferrer'
                                                                );
                                                            }}
                                                        >
                                                            <QuestionMarkIcon fontSize="small" />
                                                        </IconButton>
                                                    </Tooltip>
                                                </InputAdornment>
                                            ),
                                        },
                                    }}
                                    defaultValue={menuInput.iconName}
                                    onChange={(e) => setMenuInput({ ...menuInput, iconName: e.target.value })}
                                    sx={{ ...inputFieldSx, marginBottom: '4px' }}
                                />
                                {!selectedRow?.items && (
                                    <Box
                                        component="p"
                                        sx={{
                                            margin: 0,
                                            fontSize: '11.5px',
                                            fontWeight: 400,
                                            color: '#78909c',
                                            fontStyle: 'italic',
                                            lineHeight: 1.4,
                                            marginTop: '6px',
                                        }}
                                    >
                                        {t('menuManagement.iconPlaceHolderText')}
                                    </Box>
                                )}
                            </Box>
                        </Box>

                        <Box sx={{ flex: 1, minWidth: 0 }}>
                            {/* Country Selection Section */}
                            <Box sx={sectionCardSx}>
                                {renderSectionTitle(
                                    <LanguageIcon sx={{ fontSize: 15, color: '#1976d2' }} />,
                                    t('menuManagement.countrySelection')
                                )}

                                <FormControl
                                    fullWidth
                                    size="small"
                                    sx={{ ...inputFieldSx, marginBottom: 0, marginTop: '6px' }}
                                >
                                    <InputLabel id="countrySelectLabel">{t('menuManagement.selectCountry')}</InputLabel>
                                    <Select
                                        labelId="countrySelectLabel"
                                        id="countrySelect"
                                        multiple
                                        size="small"
                                        value={selectedCountries}
                                        onChange={handleCountrySelect}
                                        input={<OutlinedInput label={t('menuManagement.selectCountry')} />}
                                        variant="outlined"
                                        renderValue={(selected) => (
                                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                {(selected as number[]).map((value) => {
                                                    const country = countryDatas.find(
                                                        (c: any) => c.countryId === value
                                                    );
                                                    return (
                                                        <Chip
                                                            key={value}
                                                            label={country?.countryCode || value}
                                                            size="small"
                                                            sx={{
                                                                height: 22,
                                                                fontSize: '11.5px',
                                                                fontWeight: 600,
                                                                backgroundColor: '#1976d2',
                                                                color: 'white',
                                                                boxShadow: '0 1px 3px rgba(25, 118, 210, 0.3)',
                                                                transition:
                                                                    'background-color 0.2s ease, box-shadow 0.2s ease',
                                                                '&:hover': {
                                                                    backgroundColor: '#1565c0',
                                                                    boxShadow: '0 2px 6px rgba(25, 118, 210, 0.35)',
                                                                },
                                                            }}
                                                        />
                                                    );
                                                })}
                                            </Box>
                                        )}
                                    >
                                        {countryDatas.map((country: any) => {
                                            const isSelected = selectedCountries.includes(country.countryId);
                                            return (
                                                <MenuItem
                                                    key={country.countryId}
                                                    value={country.countryId}
                                                    selected={isSelected}
                                                    dense
                                                    sx={{
                                                        backgroundColor: isSelected
                                                            ? 'rgba(25, 118, 210, 0.12)'
                                                            : 'transparent',
                                                        color: isSelected ? '#1976d2' : 'inherit',
                                                        fontWeight: isSelected ? 'bold' : 'normal',
                                                        '&.Mui-selected': {
                                                            backgroundColor: 'rgba(25, 118, 210, 0.12) !important',
                                                            color: '#1976d2 !important',
                                                            fontWeight: 'bold !important',
                                                            '&:hover': {
                                                                backgroundColor: 'rgba(25, 118, 210, 0.16) !important',
                                                            },
                                                        },
                                                        '&.Mui-selected.Mui-focusVisible': {
                                                            backgroundColor: 'rgba(25, 118, 210, 0.12) !important',
                                                        },
                                                        '&:hover': {
                                                            backgroundColor: isSelected
                                                                ? 'rgba(25, 118, 210, 0.16)'
                                                                : 'rgba(0, 0, 0, 0.04)',
                                                        },
                                                    }}
                                                >
                                                    {country.countryCode} - {country.countryName}
                                                </MenuItem>
                                            );
                                        })}
                                    </Select>
                                </FormControl>
                            </Box>

                            {/* Settings Section */}
                            <Box sx={sectionCardSx}>
                                {renderSectionTitle(
                                    <SettingsIcon sx={{ fontSize: 15, color: '#1976d2' }} />,
                                    t('menuManagement.settings')
                                )}

                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        flexWrap: 'wrap',
                                        gap: '12px',
                                        padding: '10px 14px',
                                        backgroundColor: '#f5f8fc',
                                        borderRadius: '6px',
                                        border: '1px solid #cfd8dc',
                                        boxShadow: 'inset 0 1px 3px rgba(0, 0, 0, 0.04)',
                                        transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
                                        '&:hover': {
                                            borderColor: '#90caf9',
                                            boxShadow:
                                                'inset 0 1px 3px rgba(25, 118, 210, 0.06), 0 2px 8px rgba(25, 118, 210, 0.08)',
                                        },
                                    }}
                                >
                                    <FormControlLabel
                                        sx={{
                                            margin: 0,
                                            '& .MuiFormControlLabel-label': {
                                                fontSize: '13.5px',
                                                fontWeight: 500,
                                                color: '#37474f',
                                            },
                                        }}
                                        control={
                                            <Checkbox
                                                size="small"
                                                checked={menuInput.isActive ?? false}
                                                onChange={(e) => {
                                                    setMenuInput({
                                                        ...menuInput,
                                                        isActive: e.target.checked,
                                                        isHidden: !e.target.checked,
                                                    });
                                                }}
                                                sx={{
                                                    '&.Mui-checked': {
                                                        color: '#1976d2',
                                                    },
                                                    '&:hover': {
                                                        backgroundColor: 'rgba(25, 118, 210, 0.06)',
                                                    },
                                                }}
                                            />
                                        }
                                        label={t('general.active')}
                                    />
                                    <FormControlLabel
                                        sx={{
                                            margin: 0,
                                            '& .MuiFormControlLabel-label': {
                                                fontSize: '13.5px',
                                                fontWeight: 500,
                                                color: '#37474f',
                                            },
                                        }}
                                        control={
                                            <Checkbox
                                                size="small"
                                                checked={menuInput.isGlobalMenuItem}
                                                onChange={(e) => {
                                                    setMenuInput({ ...menuInput, isGlobalMenuItem: e.target.checked });
                                                }}
                                                sx={{
                                                    '&.Mui-checked': {
                                                        color: '#1976d2',
                                                    },
                                                    '&:hover': {
                                                        backgroundColor: 'rgba(25, 118, 210, 0.06)',
                                                    },
                                                }}
                                            />
                                        }
                                        label={t('general.global')}
                                    />
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </DialogContent>
                <DialogActions
                    sx={{
                        padding: '10px 20px 14px 20px',
                        gap: '10px',
                        borderTop: '1px solid #e3f2fd',
                        backgroundColor: '#fafbfc',
                    }}
                >
                    {selectedRow && selectedRow.menuItemId ? (
                        <Button
                            onClick={guncelle}
                            variant="contained"
                            size="small"
                            sx={{
                                minWidth: '88px',
                                fontWeight: 600,
                                fontSize: '13px',
                                textTransform: 'none',
                                borderRadius: '6px',
                                boxShadow: '0 2px 6px rgba(25, 118, 210, 0.25)',
                                backgroundColor: '#1976d2',
                                color: '#ffffff',
                                '&:hover': {
                                    backgroundColor: '#1565c0',
                                    boxShadow: '0 4px 12px rgba(25, 118, 210, 0.35)',
                                },
                            }}
                        >
                            {t('general.update')}
                        </Button>
                    ) : (
                        <Button
                            type="submit"
                            variant="contained"
                            size="small"
                            sx={{
                                minWidth: '88px',
                                fontWeight: 600,
                                fontSize: '13px',
                                textTransform: 'none',
                                borderRadius: '6px',
                                boxShadow: '0 2px 6px rgba(25, 118, 210, 0.25)',
                                backgroundColor: '#1976d2',
                                color: '#ffffff',
                                '&:hover': {
                                    backgroundColor: '#1565c0',
                                    boxShadow: '0 4px 12px rgba(25, 118, 210, 0.35)',
                                },
                            }}
                        >
                            {t('general.add')}
                        </Button>
                    )}
                    <Button
                        onClick={onCloseMenu}
                        variant="outlined"
                        color="primary"
                        size="small"
                        sx={{
                            minWidth: '88px',
                            fontWeight: 600,
                            fontSize: '13px',
                            textTransform: 'none',
                            borderRadius: '6px',
                            borderWidth: '1.5px',
                            borderColor: '#90caf9',
                            color: '#1565c0',
                            boxShadow: '0 1px 3px rgba(25, 118, 210, 0.08)',
                            '&:hover': {
                                borderWidth: '1.5px',
                                borderColor: '#1976d2',
                                backgroundColor: 'rgba(25, 118, 210, 0.06)',
                                boxShadow: '0 2px 8px rgba(25, 118, 210, 0.15)',
                            },
                        }}
                    >
                        {t('general.cancel')}
                    </Button>
                </DialogActions>
            </form>
        </div>
    );
};
